import { Box, Pagination, Typography } from "@mui/material"
import { ListItemBox } from "lib/@components/ListItemBox"
import { PageSize } from "lib/@components/pagination/page-size"
import { If } from "lib/@components/switch"

export function AssetPagination({
    take,
    setTake,
    skip,
    setSkip,
    totalCount,
    totalAssetCount,
    hasActiveSearch = false,
    hasActiveFilters = false,
    showCount = false,
}) {
    const currentPage = Math.floor(skip / take) + 1
    const totalPages = Math.ceil(totalCount / take)
    const summaryText = getSummaryText()

    return (
        <ListItemBox spacing={2} justifyContent="flex-end" alignItems="center">
            <If value={showCount}>
                <Typography variant="body2" data-cy="asset-count-summary">
                    {summaryText}
                </Typography>
            </If>
            <Box flex={1} />
            <Box display="flex" alignItems="center" justifyContent="flex-end" gap={2}>
                <PageSize take={take} setTake={setTake} />
                <Pagination
                    size="small"
                    color="primary"
                    count={totalPages}
                    page={currentPage}
                    onChange={handlePageChange}
                    data-cy="asset-pagination"
                />
            </Box>
        </ListItemBox>
    )

    function handlePageChange(_event, newPage) {
        setSkip((newPage - 1) * take)
    }

    function getSummaryText() {
        const hasScopedResults = hasActiveSearch || hasActiveFilters
        if (hasScopedResults && Number.isInteger(totalAssetCount)) {
            return `Showing ${totalCount} of ${totalAssetCount} assets`
        }
        if (hasScopedResults) {
            return `Showing ${totalCount} assets`
        }
        if (Number.isInteger(totalAssetCount)) {
            return `Showing ${totalAssetCount} assets`
        }
        return `Showing ${totalCount} assets`
    }
}
